
function BookmarkSVG() {
  return (
    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 16.11L8.74 13.78C8.23 13.42 7.62 13.22 7 13.22C6.37 13.22 5.77 13.41 5.26 13.78L2 16.11V2H12V16.11ZM13 0H1C0.45 0 0 0.45 0 1V18.06C0 18.27 0.07 18.47 0.19 18.64C0.51 19.09 1.13 19.2 1.58 18.88L6.42 15.43C6.77 15.18 7.23 15.18 7.58 15.43L12.42 18.88C12.87 19.2 13.49 19.1 13.81 18.65C13.93 18.48 14 18.28 14 18.07V1C14 0.45 13.55 0 13 0Z" fill="#A0A0A0"/>
    </svg>
  )
}

export { BookmarkSVG }